import { IPrecisionSite } from './precision-site.interface';
import { IProtectionSite } from './protection-site.interface';
import { ProtectionSite } from './protection-site.model';

export class PrecisionSite implements IPrecisionSite {
  constructor(
    public readonly autorisationPenetrerInterieurBatiment: boolean,
    public readonly autorisationPenetrerEspacesExterieurCloture: boolean,
    public readonly autorisationPenetrerEspacesCommun: boolean,
    public readonly categorieHabitation: string,
    public readonly typeHabitation: string,
    public readonly commentaireClient: string,
    public readonly acces: string,
    public readonly descriptionComplementaire: string,
    public readonly animaux: string,
    public readonly siret: string,
    public readonly denominationCommerciale: string,
    public readonly etage: number,
    public readonly espacesExterieurCloture: boolean,
    public readonly protectionSite: IProtectionSite | undefined,
    public readonly photos?: string[]
  ) {}

  public static hydrate(precisionSite: IPrecisionSite): IPrecisionSite {
    return new PrecisionSite(
      precisionSite.autorisationPenetrerInterieurBatiment,
      precisionSite.autorisationPenetrerEspacesExterieurCloture,
      precisionSite.autorisationPenetrerEspacesCommun,
      precisionSite.categorieHabitation,
      precisionSite.typeHabitation,
      precisionSite.commentaireClient,
      precisionSite.acces,
      precisionSite.descriptionComplementaire,
      precisionSite.animaux,
      precisionSite.siret,
      precisionSite.denominationCommerciale,
      precisionSite.etage,
      precisionSite.espacesExterieurCloture,
      precisionSite.protectionSite ? ProtectionSite.hydrate(precisionSite.protectionSite) : undefined,
      precisionSite.photos ? precisionSite.photos : []
    );
  }

  public clone(): IPrecisionSite {
    return PrecisionSite.hydrate(this);
  }
}
